export default __webpack_public_path__ + "static/banner-hong-kong-1ab0828fa08bac5b2ec3530845e51740.jpg";